import React from "react";

import { noWrap, Spinner, Stack, Text } from "@bps/fluent-ui";
import { TabsNavLinkProps } from "@components/tabs-nav/TabNav.types";
import { CustomerAccount } from "@libs/api/gateways/cam/cam-gateway.dtos";
import { useCustomerAccountQuery } from "@libs/api/gateways/cam/cam-gateway.hooks";

import { WarningIconTooltip } from "./WarningIconTooltip";

export const CustomerTabLink: React.FC<TabsNavLinkProps<CustomerAccount>> = ({
  details
}) => {
  const { data, error, isLoading } = useCustomerAccountQuery(details.id);

  return (
    <>
      {error && <WarningIconTooltip content="Error retrieving account" />}
      {!isLoading && !data?.existsInCrm && (
        <WarningIconTooltip content="BpCloud Customer Id does not exist in Dynamics" />
      )}

      <Stack
        styles={{ root: { lineHeight: "1rem", textAlign: "left", ...noWrap } }}
      >
        {isLoading ? (
          <Spinner />
        ) : (
          <Text variant="small" bold nowrap>
            {data?.businessName}
          </Text>
        )}
        <Text variant="xSmall">{details.id}</Text>
      </Stack>
    </>
  );
};
